import { apiFetch } from './http';

/**
 * Cross-device theme sync. The server stores the owner's selection plus an
 * opaque custom-theme blob (camelCase inside, round-tripped verbatim);
 * writes are last-write-wins full replaces.
 */

export interface CustomThemeBlob {
  id: string;
  name: string;
  bgHex: string;
  accentHex: string;
  textHex: string;
}

export interface AccountThemes {
  /** Builtin name or "custom:<id>" — null until the account first syncs. */
  themeSelection: string | null;
  customThemes: CustomThemeBlob[];
}

interface AccountThemesRow {
  theme_selection: string | null;
  custom_themes: CustomThemeBlob[];
}

export async function fetchAccountThemes(): Promise<AccountThemes> {
  const row = await apiFetch<AccountThemesRow>('/api/account/themes');
  return {
    themeSelection: row.theme_selection ?? null,
    customThemes: Array.isArray(row.custom_themes) ? row.custom_themes : [],
  };
}

export async function saveAccountThemes(
  { themeSelection, customThemes }: { themeSelection: string; customThemes: CustomThemeBlob[] },
): Promise<void> {
  await apiFetch('/api/account/themes', {
    method: 'PUT',
    body: JSON.stringify({ theme_selection: themeSelection, custom_themes: customThemes }),
  });
}
